import { Component, Element, h, Host, Listen, Prop } from '@stencil/core';
import { searchAction } from './state/quick-search.action';
import { get as getState, set as setState } from './state/quick-search.state';
import get from 'lodash/get';

@Component({
  tag: 'quick-product-search',
  styleUrl: 'quick-product-search.scss',
})
export class QuickProductSearch {
  @Prop() productRoute: string;

  @Prop() region: string;

  @Element() el: HTMLElement;

  translate = (key) => {
    return get(window['quickProductSearch'], key, key);
  }

  componentWillLoad() {
    setState('productRoute', this.productRoute);
    setState('region', this.region);
  }

  @Listen('resize', { target: 'window' })
  handleOrientationChange() {
    setTimeout(() => {
      if (!this.el.offsetParent && getState('result')) {
        setState('result', null);
        setState('query', '');
      }
    });
  }

  private onFormSubmit(event: Event) {
    event.preventDefault();
    setState('currentPage', 1);
    searchAction();
  }

  private onInputChange(event) {
    setState('query', event.target.value);
    setState('currentPage', 1);
    const disallowSearch = getState('query').length < 2;

    if (disallowSearch) {
      setState('result', null);
      return;
    }

    searchAction(600);
  }

  render() {
    return <Host>
      <form class="quick-product-search"
            onSubmit={event => this.onFormSubmit(event)}>
        <input class="quick-product-search__input"
               type="search"
               value={getState('query')}
               placeholder={this.translate('inputPlaceholder')}
               onInput={(event) => this.onInputChange(event)}
        />

        <button aria-label={this.translate('searchButton')}
                class="quick-product-search__button">
          <i class="icon icon-search"/>
        </button>
      </form>

      {getState('result') ? <quick-search-results/> : ''}
    </Host>;
  }
}
